import Box from '@amzn/awsui-components-react/polaris/box';
import Icon from '@amzn/awsui-components-react/polaris/icon';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Button from '@amzn/awsui-components-react/polaris/button';

import { getTimestampString } from 'common';
import { getString } from 'common/ui-string-labels/ui-strings-utils';
import './PendingAttachmentFile.scss';

const stringPath = "orderDetails.tabs.orderSummary.fileDropzone";

interface PendingAttachmentFileProps {
    file: File;
    onDismiss: () => void;
}

/**
 * Formats a file size in bytes to a human-readable string.
 */
export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return "0 B";
    const units = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const size = (bytes / Math.pow(1024, i)).toFixed(i > 0 ? 1 : 0);
    return `${size} ${units[i]}`;
};

/**
 * Displays a pending (not yet uploaded) attachment file in the same layout as AttachmentFile,
 * but with a blue left border to distinguish it from existing attachments, and an X button
 * to dismiss instead of a download button.
 */
export const PendingAttachmentFile = ({ file, onDismiss }: PendingAttachmentFileProps) => {
    return (
        <Box
            data-testid="pending-attachment-file"
            padding={{ left: "s", top: "xs", bottom: "xs", right: "s" }}
        >
            <div className="pending-attachment">
                <SpaceBetween direction="horizontal" size="xs">
                    <Icon variant="link" name="file" />
                    <Box>
                        <Box data-testid="pending-attachment-filename">
                            <span title={file.name}>{file.name}</span>
                        </Box>
                        <SpaceBetween direction="vertical" size="xxxs">
                            <Box fontSize="body-s" color="text-body-secondary">
                                {formatFileSize(file.size)}
                            </Box>
                            {file.lastModified && (
                                <Box fontSize="body-s" color="text-body-secondary">
                                    {getTimestampString(new Date(file.lastModified))}
                                </Box>
                            )}
                            <Button
                                data-testid="pending-attachment-dismiss"
                                variant="inline-link"
                                onClick={onDismiss}
                                iconName="close"
                            >
                                {getString(`${stringPath}.fileList.removeFile`)}
                            </Button>
                        </SpaceBetween>
                    </Box>
                </SpaceBetween>
            </div>
        </Box>
    );
};
